/**
 * Dashboard data runtime — public entry point.
 *
 * Importing this module registers the built-in source providers
 * (nats / doris / hybrid). Consumers use {@link usePanelData} + the spec types.
 */

import { registerProvider } from './providers/registry';
import { WorkerNatsSeriesProvider } from './providers/WorkerNatsSeriesProvider';
import { DorisSeriesProvider } from './providers/DorisSeriesProvider';
import { HybridSeriesProvider } from './providers/HybridSeriesProvider';

registerProvider(new WorkerNatsSeriesProvider());
registerProvider(new DorisSeriesProvider());
registerProvider(new HybridSeriesProvider());

export * from './spec';
export { usePanelData } from './usePanelData';
export type { PanelData } from './usePanelData';
export type {
  SeriesPoint,
  SeriesPatch,
  SeriesProvider,
  SeriesSubscription,
  ProviderContext,
} from './providers/SeriesProvider';
export { registerProvider, getProvider, hasProvider } from './providers/registry';
